<template>
    <div>
      <SGPRowComponent>
        <div class="p-4">
          <form @submit.prevent="submit()">
            <SGPRowComponent>
              <SGPColComponent cols="4" class="mb-3">
                <h4 class="mb-3"> Digite a SEV</h4>
                <SGPFormInputComponent
                  name="sev"
                  type="text"
                  placeholder="SEV"
                  v-model="formulario.sev"       
                />
              </SGPColComponent>
              <SGPColComponent cols="4" class="mb-3 mt-10">
                <SGPFormBotaoComponent
                  type="submit"
                  color="primary"
                  block
                  rounded
                  middle
                >
                  <span>Consultar</span>
                </SGPFormBotaoComponent>
              </SGPColComponent>
            </SGPRowComponent>
          </form>
          <div v-if="retorno">
            <br>
            <SGPRowComponent>
              <InformacoesDadosSevComponent
                v-if= this.retorno
                :pcoCircuitoSSA= this.retorno
                :numeroSev=this.formulario.sev
              ></InformacoesDadosSevComponent>
            </SGPRowComponent>
          </div>
        </div>
      </SGPRowComponent>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import InformacoesDadosSevComponent from '@/modules/workflow/shared/ficha-tecnica/components/GridInformacoes/InformacoesDadosSevHomePageComponent.vue' 
export default {
  name: 'ModalConsultaAutomacaoComponent',
  components: {
    InformacoesDadosSevComponent
  },
  props:{
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    dadosFichaTecnica: {
      type: Array,
      required: true
    },
  },
  data () {
    return {    
        submitForm: false,
        formulario: {
            sev: ''
        },
        retorno: null
      }
    },

  mounted() {
    if (this.value) {
      this.formulario.sev = this.value.sev;
    }
  },

  methods: {
    ...mapActions('automacao', [
      'consultaSEV'
    ]),
    async submit() {
      this.submitForm = true;
      try {
        let response = await this.consultaSEV(this.formulario.sev);

        if (response && response.data) {
          this.retorno = response.data.message.success;
        } else {
          // Handle error or empty response
          console.error('Erro ao obter dados:', response);
          // Optionally, show an error message to the user
          // this.retorno = { error: 'Erro ao obter dados.' };
        }
      } catch (error) {
        console.error('Erro na requisição:', error);
        // Handle network errors or other exceptions
        // this.retorno = { error: 'Erro na requisição.' };
      }
    },
  }
}

</script>
<style>

</style>